<template>
    <div class="diagnose">
        <el-dialog center :modal="true" :visible.sync="dialogVisible" width="700px" :close-on-click-modal="false">
            <template slot="title">
                <div style="display: flex;">
                    <div>协诊</div>
                    <div style="color: #67C23A;font-size: 12px;">
                        <i class="el-icon-warning" style="color: #67C23A;margin-top: 3px;margin-left: 10px;"></i>
                        新增
                    </div>
                </div>
            </template>

            <div>
                <el-row>
                    <el-descriptions :column="2" size="mini" border>
                        <template slot="title">
                            <el-col :span="2">
                                <img style=" margin-left: -15px; margin-top: -1px;width: 30px;height: 20px;"
                                    :src="linkLine" />
                            </el-col>

                            <el-col :span="22">
                                <span style="margin-left: 0px">协诊申请单</span>
                            </el-col>
                        </template>

                        <el-descriptions-item label="申请类型">
                            <el-select placeholder="请选择">
                                <el-option label="向上协诊" value="1"></el-option>
                                <el-option label="向下转诊" value="2"></el-option>
                            </el-select>
                        </el-descriptions-item>

                        <el-descriptions-item label="接诊医院">
                            <el-select placeholder="请选择">
                                <el-option label="选项1" value="1"></el-option>
                                <el-option label="选项2" value="2"></el-option>
                            </el-select>
                        </el-descriptions-item>

                        <el-descriptions-item label="协诊医生">
                            <el-select placeholder="请选择">
                                <el-option label="选项1" value="1"></el-option>
                                <el-option label="选项2" value="2"></el-option>
                            </el-select>
                        </el-descriptions-item>

                        <el-descriptions-item label="接诊科室">
                            <el-select placeholder="请选择">
                                <el-option label="选项1" value="1"></el-option>
                                <el-option label="选项2" value="2"></el-option>
                            </el-select>
                        </el-descriptions-item>

                        <el-descriptions-item label="初步诊断" :span="2">
                            <el-input type="textarea" :rows="2" placeholder="请输入内容"></el-input>
                        </el-descriptions-item>

                        <el-descriptions-item label="患者主诉" :span="2">
                            <el-input type="textarea" :rows="2" placeholder="请输入内容"></el-input>
                        </el-descriptions-item>

                        <el-descriptions-item label="申请原因">
                            <el-select placeholder="请选择">
                                <el-option label="选项1" value="1"></el-option>
                                <el-option label="选项2" value="2"></el-option>
                            </el-select>
                        </el-descriptions-item>
                    </el-descriptions>

                    <el-descriptions :column="2" size="mini" border style="margin-top: 20px;">
                        <template slot="title">
                            <el-col :span="2">
                                <img style=" margin-left: -15px; margin-top: -1px;width: 30px;height: 20px;"
                                    :src="linkLine" />
                            </el-col>

                            <el-col :span="22">
                                <span style="margin-left: 0px">患者信息</span>
                            </el-col>
                        </template>

                        <el-descriptions-item label="姓名"></el-descriptions-item>
                        <el-descriptions-item label="住址"></el-descriptions-item>
                        <el-descriptions-item label="身份证号"></el-descriptions-item>
                        <el-descriptions-item label="联系方式"></el-descriptions-item>
                        <el-descriptions-item label="联系人"></el-descriptions-item>
                        <el-descriptions-item label="联系电话"></el-descriptions-item>                        
                    </el-descriptions>

                    <el-descriptions :column="2" size="mini" border style="margin-top: 20px;">
                        <template slot="title">
                            <el-col :span="2">
                                <img style=" margin-left: -15px; margin-top: -1px;width: 30px;height: 20px;"
                                    :src="linkLine" />
                            </el-col>

                            <el-col :span="22">
                                <span style="margin-left: 0px">申请医生信息</span>
                            </el-col>
                        </template>

                        <el-descriptions-item label="申请医生"></el-descriptions-item>
                        <el-descriptions-item label="所属机构"></el-descriptions-item>
                        <el-descriptions-item label="所属科室"></el-descriptions-item>
                        <el-descriptions-item label="联系电话"></el-descriptions-item>
                    </el-descriptions>
                </el-row>

                <!-- <span slot="footer">
                    <el-button type="primary" @click="dialogVisible = false">关闭</el-button>
                </span> -->
            </div>

        </el-dialog>
    </div>
</template>
<script>

import imageLine from "@/assets/images/titleLine.png";

export default {
    data() {
        return {
            dialogVisible: false,
            linkLine: imageLine,
            diagnoseFormData: {},
            patientMsg: null,
            applyDiagnosisOptions: []
        };
    },
    methods: {
        // 初始化组件
        async init() {
            this.dialogVisible = true;
        }
    }
};
</script>

<style></style>